// extracted by mini-css-extract-plugin
export var chevron = "_jb-4";
export var chevronExpanded = "_jb-5";
export var row = "_jb-0";
export var rowBody = "_jb-6";
export var rowDescription = "_jb-7";
export var rowHeader = "_jb-1";
export var rowTitle = "_jb-2";
export var rowTitleComplete = "_jb-3";